import { SerializedStateManagerV1 } from '@feature-hub/serialized-state-manager';

export const processSerializedStates = (
  serializedStateManager: SerializedStateManagerV1,
): void => {
  const serializedStates = getSerializedStatesFromDom();

  if (serializedStates) {
    serializedStateManager.setSerializedStates(serializedStates);
  }
};

export const getSerializedStatesFromDom = (): string | undefined => {
  const scriptElement = document.querySelector(
    'script[type="x-feature-hub/serialized-states"]',
  );

  return (scriptElement && scriptElement.textContent) || undefined;
};
